<template>
  <div class="d-sm-flex" style="height: 100%; overflow-y: auto; overflow-x: hidden;">
    <div>
      <v-list>
        <v-subheader>Физ. лица</v-subheader>
        <v-list-item-group mandatory v-model="selectedPerson" color="primary">
          <v-list-item v-for="person in fl" :key="person.id" :color="person.is_approved === false ? 'error' : ''">
            <v-list-item-content>
              <v-list-item-title v-text="person.name"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-avatar v-if="person.is_approved === false">
              <v-icon color="error">mdi-alert-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-if="person.is_approved === true">
              <v-icon color="success">mdi-check-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-if="person.is_approved === null && person.sended">
              <v-icon color="warning">mdi-clock-time-eight-outline</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <v-divider class="d-none d-sm-block" vertical></v-divider>
    <div class="flex-grow-1">
      <v-alert class="mb-0" style="overflow-wrap: anywhere" v-if="interruptReason" tile dense type="error">{{
        interruptReason
      }}</v-alert>
      <v-alert v-if="show_main_wait" tile dense type="warning">Ожидается загрузка документов</v-alert>
      <v-container>
        <h4 v-if="!show_success && !show_wait" class="font font--color_light mb-2">
          Загрузите документы для всех физ. лиц и отправьте их на проверку
        </h4>
        <v-alert v-if="show_comment" type="error" color="red lighten-2">{{ comment }}</v-alert>
        <v-alert v-if="show_success" type="success" color="green lighten-2">Документы прошли проверку</v-alert>
        <v-alert v-if="show_wait" icon="mdi-timer-sand-empty" color="yellow lighten-4"
          >Документы отправлены на проверку</v-alert
        >
        <v-row class="mb-5">
          <v-col v-for="attachment in attachmentsWithOneFile" :key="attachment.name">
            <AttachmentUpload
              @attachment-file-add="addFile"
              @attachment-file-remove="onFileRemove"
              :value="getAttachmentFileOrNothing(attachment.files, 0)"
              :label="attachment.title"
              :name="attachment.name"
              :context-id="oid"
              :context-name="attachmentMetadata.contextName"
              :group-name="attachmentMetadata.groupName"
            />
          </v-col>
        </v-row>
        <v-row v-for="attachment in attachmentsWithMultipleFiles" :key="attachment.name">
          <v-col>
            <AttachmentUpload
              multi
              @attachment-file-add="addFile"
              @attachment-file-remove="onFileRemove"
              :value="attachment.files"
              :label="attachment.title"
              :name="attachment.name"
              :context-id="oid"
              :context-name="attachmentMetadata.contextName"
              :group-name="attachmentMetadata.groupName"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import AttachmentUpload from "@/components/common/AttachmentUpload";

export default {
  components: {
    AttachmentUpload
  },
  data() {
    return {
      selectedPerson: 0,
      attachmentMetadata: {
        contextName: 'app:person',
        groupName: 'fl_resident_passport'
      },
    };
  },
  computed: {
    ...mapGetters("meeting", ["fl", "isAllFlDocsSended", "interruptReason"]),

    // доки для выбранного лица:
    attachmentsList() {
      const attachments = this.fl[this.selectedPerson]?.attachments;
      if (!attachments) {
        return [];
      }

      return attachments.map(item => {
        const maxFiles = item.properties?.max_files;
        const minFiles = item.properties?.min_files ?? 0;
        return {
          ...item,
          isMultiple: (!maxFiles || maxFiles > 1 || minFiles > 1)
        }
      });
    },

    attachmentsWithOneFile() {
      return this.attachmentsList.filter(attachment => !attachment.isMultiple);
    },

    attachmentsWithMultipleFiles() {
      return this.attachmentsList.filter(attachment => attachment.isMultiple);
    },

    // для привязки файлов к фл по его id
    oid() {
      return this.fl[this.selectedPerson]?.id;
    },

    comment() {
      return this.fl[this.selectedPerson]?.comment;
    },
    show_comment() {
      return this.fl[this.selectedPerson]?.is_approved === false;
    },
    show_success() {
      return this.fl[this.selectedPerson]?.is_approved === true;
    },
    show_wait() {
      return this.sended && this.fl[this.selectedPerson]?.is_approved === null;
    },
    sended() {
      return this.fl[this.selectedPerson]?.sended;
    },
    show_main_wait() {
      return !this.isAllFlDocsSended;
    },
  },

  methods: {
    ...mapMutations("meeting", ["setAccountOpenStep", "setFlDocsFor"]),

    getAttachmentFileOrNothing: (list, idx) => list?.[idx],
    getAttachmentPropertyOrNothing: (attachment, property) => attachment.properties?.[property],

    updateCurrentPersonAttachmentsList(name, files) {
      const attachmentFiles = this.attachmentsList.find(item => item.name === name);
      if (attachmentFiles) {
        attachmentFiles.files = files;
        this.setFlDocsFor({ index: this.selectedPerson, docs: this.attachmentsList });
      }
    },

    addFile({ name, updatedList }) {
      this.updateCurrentPersonAttachmentsList(name, updatedList);
    },

    onFileRemove({ name, updatedList }) {
      this.updateCurrentPersonAttachmentsList(name, updatedList);
    },
  },
};
</script>
